import moment from "moment";

class BusinessUnit {
  constructor(isDefault, dateStart, dateEnd, name, id) {
    this.isDefault = isDefault;
    this.isDefaultBool = isDefault === "S";
    this.isDefaultTable = isDefault === "S" ? "✔️" : "";
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
    this.id = id;
    this.name = name;
  }

  static fromJson({ def, fecDesde, fecHasta, nombre, unNegocioId }) {
    return new BusinessUnit(def, fecDesde, fecHasta, nombre, unNegocioId);
  }
}

export default BusinessUnit;
